import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { updateDataTable } from '../DataTable/redux/dataTableActions';

export const IS_SUBMITTING = 'socrates-online/notes/IS_SUBMITTING';

export const initialState = {
  isSubmitting: false,
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case IS_SUBMITTING:
      return {
        ...state,
        isSubmitting: action.data,
      };
    default:
      return state;
  }
}

export function createNote(note, application, resourceType) {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.post(
      resourceType + '/' + application.data.id + '/notes?include=attachments',
      note,
    )
      .then((resp) => {
        toastr.success('Success', 'Your note has been saved');
        dispatch(
          updateDataTable(
            application.data.id,
            resp?.data.data,
            resp?.data.included ?? [],
            true,
          ),
        );
        return resp.data;
      })
      .finally(() => {
        dispatch(isSubmitting(false));
      });
  };
}

export function createMultipleNotes(notes, resourceType) {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.post(resourceType + '/notes', notes)
      .then(() => {
        // toastr.success('Success', 'Your note has been saved')
      })
      .finally(() => {
        dispatch(isSubmitting(false));
      });
  };
}

const isSubmitting = (state) => ({ type: IS_SUBMITTING, data: state });
